import { TechnicalError } from '@dch/products-business-logic';
import * as OffersActions from '../actions/offers.actions';
import { IOffer } from '@proximus/common-business-logic';

export interface OffersState {
  offer: IOffer;
  isPending: boolean;
  error: TechnicalError;
}

export const initialState: OffersState = {
  offer: null,
  isPending: false,
  error: null,
};

export function reducer(
  state: OffersState = initialState,
  action: OffersActions.Actions,
): OffersState {
  switch (action.type) {
    case OffersActions.GET_COPPER_OUT_PHASING_OFFER:
      return {
        ...state,
        isPending: true,
        error: null,
      };
    case OffersActions.GET_COPPER_OUT_PHASING_OFFER_SUCCESS:
      return {
        ...state,
        offer: action.payload,
        isPending: false,
        error: null,
      };
    case OffersActions.GET_COPPER_OUT_PHASING_OFFER_FAILED:
      return {
        ...state,
        offer: null,
        error: action.payload,
        isPending: false,
      };
    default:
      return state;
  }
}

export const getCopperOutPhasingOffer = (state: OffersState) => state.offer;
export const getTechnicalError = (state: OffersState) => state.error;
export const getPending = (state: OffersState) => state.isPending;
